import type { DeviceModel } from '../../types/deviceModel';
import { portRow, powerPort, simpleLayout } from './layoutHelpers';
import type { MultiFaceLayout } from '../../types';

const follows = {
  standards: ['802.3af', '802.3at', 'passive-24', 'passive-48'] as const,
  perPortMaxWatts: 30,
  modeDefault: 'auto' as const,
  outputFollowsInputVoltage: true,
  poeOutOnlyWhenPoweredBy: ['dc-terminal'] as Array<'dc-terminal'>,
};

export const css610Model: DeviceModel = {
  equipmentId: 'mikrotik-css610-8p',
  selfDrawWatts: 12,
  powerInputs: [
    { id: 'dc-term', kind: 'dc-terminal', portNumber: 1, face: 'back', voltageMin: 12, voltageMax: 57, maxWatts: 160 },
  ],
  powerSelect: 'highest-voltage',
  layout: {
    numberingSchemeId: 'mikrotik',
    multiFace: {
      defaultFace: 'front',
      faces: {
        front: simpleLayout(
          [
            ...portRow({
              count: 8,
              startNumber: 1,
              kind: 'rj45',
              labelPrefix: 'ether',
              speedsMbps: [10, 100, 1000],
              poeOut: { ...follows, standards: [...follows.standards] },
              y: 18,
            }),
            ...portRow({
              count: 2,
              startNumber: 1,
              kind: 'sfpPlus',
              labelPrefix: 'sfpplus',
              speedsMbps: [1000, 10000],
              startX: 12 + 24 * 8,
              y: 18,
              idPrefix: 'sfpplus',
            }),
          ],
          300,
          70
        ),
        back: simpleLayout(
          [powerPort({ number: 1, kind: 'dc', label: '2-pin DC', x: 12, y: 20 })],
          140,
          70
        ),
      },
    } as MultiFaceLayout,
  },
};
